export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = vendor